// extracted by mini-css-extract-plugin
module.exports = {"logout":"logout_logout__2pFMB","icon":"logout_icon__3UsBC"};